import { makeZonedApiCall } from "./makeApiCall";
import type {
  CustomerFormDetail,
  CustomerFormPage,
  FormAction,
  FormOptions,
  FormSubmission,
  FormSubmissionResult,
  FormType,
} from "../types/forms";

export const customerFormsApi = {
  list: (query: URLSearchParams) =>
    makeZonedApiCall<CustomerFormPage>("get", `forms?${query.toString()}`),
  options: () => makeZonedApiCall<FormOptions>("get", "forms/options"),
  detail: (type: FormType, id: string | number) =>
    makeZonedApiCall<CustomerFormDetail>("get", `forms/${type}/${id}`),
  submit: (type: FormType, customerId: number, payload: FormSubmission) =>
    makeZonedApiCall<FormSubmissionResult, FormSubmission>(
      "post",
      `mobile/customers/${customerId}/${type}-requests`,
      payload
    ),
  transition: (type: FormType, id: number, payload: FormAction) =>
    makeZonedApiCall<CustomerFormDetail, FormAction>(
      "post",
      `forms/${type}/${id}/transitions`,
      payload
    ),
  reopen: (type: FormType, id: number, payload: FormAction) =>
    makeZonedApiCall<CustomerFormDetail, FormAction>("post", `forms/${type}/${id}/reopen`, payload),
  reschedule: (id: number, payload: FormAction) =>
    makeZonedApiCall<CustomerFormDetail, FormAction>("patch", `forms/demo/${id}/schedule`, payload),
};
